import RedCar from '../../../assets/images/red_car_background.png';
import Gear from '../../../assets/images/gear.png';
import Repair from '../../../assets/images/repair.png';
import Medal from '../../../assets/images/medal.png';
import Coin from '../../../assets/images/coin.png';
import Collectible from '../../../assets/images/collectible.png';
import Trophy from '../../../assets/images/trophy.png';
import { BUY_LINK } from '../../../constants';
import './RaceXTool.css';

const RaceXTool = () => {
  return (
    <div className='racexTool'>
      <div className='racexTool__box'>
        <label className='racexTool__title'>What can I do with my RaceX tokens?</label>
        
        <div className='racexTool__tool__box'>
          <div className='racexTool__tool'>
            <img src={Gear} width='40px' height='40px' alt='tool' />
            <label className='racexTool__tool__desc'>
              Use RaceX to upgrade you vehicles (with burning functions)
            </label>
          </div>
          <div className='racexTool__tool'>
            <img src={Repair} width='40px' height='40px' alt='tool' />
            <label className='racexTool__tool__desc'>
              Keep your car maintained, such as oil changes
            </label>
          </div>
          <div className='racexTool__tool'>
            <img src={Medal} width='40px' height='40px' alt='tool' />
            <label className='racexTool__tool__desc'>
              Practice racing to increase your skill level
            </label>
          </div>
          <div className='racexTool__tool'>
            <img src={Coin} width='40px' height='40px' alt='tool' />
            <label className='racexTool__tool__desc'>
              Player vs Player races. Stake any amount to bet on races.
            </label>
          </div>
          <div className='racexTool__tool'>
            <img src={Trophy} width='40px' height='40px' alt='tool' />
            <label className='racexTool__tool__desc'>
              Enter a high stakes racing tournament and be the champion
            </label>
          </div>
        </div>

        <div className='racexTool__tool__box'>
          <a href={BUY_LINK} target='_blank' className='home__btn__mint' style={{width:'120px', margin:'0'}}>Buy $RaceX</a>
          <label className='racexTool__desc'>
            * Many of these features are in the very beginning of development and will be integrated over time
          </label>
        </div>
      </div>
      <div className='racexTool__img'>
        <img src={RedCar} width='100%' alt='red car'/>
      </div>
    </div>
  )
}

export default RaceXTool;